export const SHARED_LOOKUP_CATEGORIES = '[ Shared ] Fetch lookup categories'
export const SHARED_OFFERS = '[ Shared ] Fetch offers'
export const SHARED_ORGANISATIONS = '[ Shared ] Fetch organisations'
export const SHARED_RESOURCES = '[ Shared ] Fetch resources'

export const SHARED_RESOURCES__CREATE = '[ Shared ] Create resource'
